import PublicApiModel from './globals/PublicApiModel';

export default class LoginCheckModel extends PublicApiModel {
  static get path() {
    return '/backend/login_check';
  }
}
